export interface SecondaryAction {
	label: string;
	onSelect: () => void;
	dataQaId?: string;
}

export interface CheckoutHandoff {
	basket_id: string;
	checkout_url: string;
}

export interface FwJsShopHostApi {
	mount: (container: Element) => unknown;
	unmount: (container: Element) => void;
}

declare global {
	interface Window {
		ACCESS_TOKEN?: string;
		// Set by main.tsx so a single-page host can mount the app again without reloading the bundle.
		fwJsShop?: FwJsShopHostApi;
		js_config: {
			page_to_load: string;
			locale: string;
			API_BASE_URL: string;
			cb_site: string;
			cb_key: string;
			access_token?: string;
			bugsnag?: {
				apiKey: string;
				releaseStage: string;
			};
			// Set by a host page that embeds the shop (the parent cancel flow), never by the backend:
			// a text action rendered beside the plan CTA, e.g. "I still want to cancel".
			secondary_action?: SecondaryAction;
			// Set by a host page that knows the subscription being replaced (the parent cancel flow):
			// when the downgraded plan starts, already formatted for display ("12 september 2026").
			// Absent when the plan starts right away.
			downgrade_start_date?: string;
			// Set by a host page that embeds both the shop and the checkout (the parent cancel flow):
			// called instead of navigating to `checkout_url` once the basket exists.
			on_checkout?: (handoff: CheckoutHandoff) => void;
			// Set by a single-page host: follows a link the shop renders (edit order) inside the host app
			// instead of letting the browser load the page.
			navigate?: (url: string) => void;
		};
		__INITIAL_DATA__: object;
	}
}

export function getAppConfig(): Window['js_config'] | undefined {
	if (typeof window !== 'undefined') {
		return window.js_config;
	}
	return undefined;
}
